function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import CarouselGallary from "/components/core/carousel-gallary/carousel-gallary";
import { CUSTOMER_TESTIMONIAL_CHANGED_MANUALLY } from "constants/bigbrain-event-types";
import { trackEvent } from "services/bigbrain-service";
import TestimonialComponent from "./testimonial/testimonial-component";
import { StyledCarouselTestimonialsComponent } from "./carousel-testimonials-component.scss";
import DefaultProps from "./default-props";
const DEFAULT_AUTOPLAY_INTERVAL = 10000; // 10 seconds
class CarouselTestimonialsComponent extends PureComponent {
    render() {
        const { autoplay, carouselWidth } = this.props;
        const { shouldAutoPlay, interval, pauseOnHover, wrapAround } = autoplay;
        return /*#__PURE__*/ _jsx(StyledCarouselTestimonialsComponent, {
            className: "carousel-testimonials-component",
            children: /*#__PURE__*/ _jsx(CarouselGallary, {
                className: "carousel-item",
                autoplay: shouldAutoPlay,
                autoplayInterval: Number(interval) || DEFAULT_AUTOPLAY_INTERVAL,
                pauseOnHover: pauseOnHover,
                wrapAround: wrapAround,
                edgeEasing: "easeBack",
                slidesToShow: 1,
                slideIndex: 1,
                cellAlign: "center",
                cellSpacing: 16,
                width: carouselWidth,
                slideWidth: 0.7,
                renderCenterLeftControls: ()=>{},
                renderCenterRightControls: ()=>{},
                heightMode: "max",
                bottomCenterExtraProps: {
                    onButtonClick: this.onManualTestimonialChange
                },
                children: this.renderTestimonials()
            })
        });
    }
    constructor(...args){
        super(...args);
        _define_property(this, "onManualTestimonialChange", (index)=>{
            const { testimonials, testimonialChangeEventData } = this.props;
            const selected = testimonials[index];
            const { name } = selected;
            trackEvent(CUSTOMER_TESTIMONIAL_CHANGED_MANUALLY, _object_spread({
                info1: index,
                info2: name
            }, testimonialChangeEventData));
        });
        _define_property(this, "renderTestimonials", ()=>{
            const { testimonials } = this.props;
            return testimonials.map((testimonial)=>{
                return /*#__PURE__*/ _jsx(TestimonialComponent, {
                    testimonial: testimonial
                }, testimonial.name);
            });
        });
    }
}
export { CarouselTestimonialsComponent as default };
CarouselTestimonialsComponent.defaultProps = DefaultProps;
